<template>
  <span class="custom" :class="{ on: picked }">
    <label
      class="custom-swatch"
      :style="{ background: picked ? colour(value).fill : RAINBOW }"
      title="Custom colour"
    >
      <input
        type="color"
        :value="picked ? normaliseHex(value) : '#3fa9f5'"
        :aria-label="label"
        :aria-checked="picked"
        role="radio"
        @change="pick($event.target.value)"
      >
    </label>
    <input
      class="hex"
      type="text"
      :value="picked ? normaliseHex(value) : ''"
      placeholder="#hex"
      maxlength="7"
      spellcheck="false"
      autocomplete="off"
      autocapitalize="off"
      :aria-label="`${label} hex code`"
      @change="typed"
      @keydown.enter="$event.target.blur()"
    >
  </span>
</template>

<script>
import { colour, isCustom, normaliseHex } from '@/account/palette.js';

const RAINBOW = 'conic-gradient(#ff5b5b, #ffcc3d, #a3e635, #2ec4b6, #5b7cff, #d946ef, #ff5b5b)';

// The thirteenth swatch: any colour at all, from the browser's colour picker
// or typed as a hex code. Emits 'pick' with the hex.
export default {
  name: 'CustomSwatch',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Custom colour' },
  },
  emits: ['pick'],
  data() { return { RAINBOW }; },
  computed: {
    picked() { return isCustom(this.value); },
  },
  methods: {
    colour,
    normaliseHex,
    pick(text) {
      const hex = normaliseHex(text);
      if (hex) this.$emit('pick', hex);
    },
    typed(e) {
      const hex = normaliseHex(e.target.value);
      if (hex) this.$emit('pick', hex);
      else e.target.value = this.picked ? normaliseHex(this.value) : '';
    },
  },
};
</script>

<style scoped>
.custom { display: inline-flex; align-items: center; gap: 0.4rem; }
.custom-swatch {
  position: relative; display: block; box-sizing: border-box; cursor: pointer;
  width: var(--swatch, 26px); height: var(--swatch, 26px); border-radius: 50%;
  border: var(--ring, 2px) solid transparent;
}
.on .custom-swatch { border-color: #fff; box-shadow: 0 0 0 var(--ring, 2px) #12141c inset; }
.custom-swatch input {
  position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; border: 0; padding: 0;
}
.hex {
  width: 5.2em; font: inherit; font-size: 1rem; /* 16px+ so iOS doesn't zoom */ font-family: ui-monospace, Menlo, monospace;
  background: #12141c; color: #eef0f6; border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px; padding: 0.3rem 0.45rem;
}
.on .hex { border-color: rgba(255, 255, 255, 0.6); }
</style>
